import type { FC } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import ConvertionMoneyIcon from '@public/assets/casino/icons/convertionMoney.svg';
import { ModalMessage } from '@/components/ModalMessage/ModalMessage';
import { useGameGoBack } from '../../CasinoGamePage.hooks';
import type { PopupBalanceConversionProps } from './PopupBalanceConversion.types';
import styles from './PopupBalanceConversion.module.scss';
const popupClasses = {
  wrapper: styles.wrapper
};
export const PopupBalanceConversion: FC<PopupBalanceConversionProps> = ({
  defaultIsShow,
  onStartLoading,
  game
}) => {
  const {
    t
  } = useTranslation('common');
  const [show, setShow] = useState(false);
  const back = useGameGoBack(game);
  const handleClick = useCallback(() => {
    setShow(false);
    onStartLoading();
  }, [onStartLoading]);
  const handleClose = useCallback(() => {
    setShow(false);
    back();
  }, [back]);
  useEffect(() => {
    setShow(defaultIsShow);
  }, [defaultIsShow]);
  return <ModalMessage title={t('modal_message.balance_conversion', 'When playing, your balance will be converted into EUR')} show={show} icon={<ConvertionMoneyIcon className={styles.icon} />} onClose={handleClose} onClick={handleClick} buttonText={t('modal_message.proceed', 'Proceed')} popupClasses={popupClasses} data-sentry-element="ModalMessage" data-sentry-component="PopupBalanceConversion" data-sentry-source-file="PopupBalanceConversion.tsx" />;
};